import type { BatteryConcertApplicationStatusDto } from "~/api/dto/battery-concert-application.dto"

import { batteryConcertApplicationBundle } from "./battery-concert-bundle"
import {
  ConcertApplicationForm,
  type ConcertApplicantPrefill,
} from "../../../ProposalSetup/financing/concert/ConcertApplicationForm"

export {
  ADD_CO_APPLICANT_LABEL,
  CONCERT_APPLICATION_TITLE,
  CONCERT_SUBMIT_FAILED_MESSAGE,
  DISCLOSURE_ACCEPT_LABEL,
  HOMEOWNER_EMAIL_REQUIRED_MESSAGE,
  OWNER_VERIFIED_LABEL,
  PRICING_REFRESHED_MESSAGE,
  REMOVE_CO_APPLICANT_LABEL,
  RESIDENT_VERIFIED_LABEL,
  SUBMIT_APPLICATION_LABEL,
} from "../../../ProposalSetup/financing/concert/ConcertApplicationForm"
export { CONCERT_SETUP_REQUIRED_MESSAGE } from "./battery-concert-bundle"

/** Homeowner and Site facts the form opens with; the server confirmed them. */
export type ConcertBatteryApplicantPrefill = ConcertApplicantPrefill

/** Concert's in-person Battery application: the shared form over Battery's submit. */
export function ConcertBatteryApplicationForm(props: {
  proposalId: string
  quoteId: string
  prefill: ConcertBatteryApplicantPrefill
  onClose: () => void
  /** Null when the server reports an Existing Loan Application already. */
  onSubmitted: (status: BatteryConcertApplicationStatusDto | null) => void
}): JSX.Element {
  return (
    <ConcertApplicationForm
      bundle={batteryConcertApplicationBundle}
      {...props}
    />
  )
}
